import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import { store } from '@/store';
import { Toast, Dialog } from 'vant';
import router from '@/router';
import { encrypt, decrypt, isEncrypted } from '@/utils/encrypt';
const catcher = {
  config: {
    time: 30 * 1000,
  },
  data: {},
};

Vue.use(Toast);
Vue.use(Dialog);

let isError = false;
// 根据环境不同引入不同api地址
// create an axios instance

const service = axios.create({
  baseURL: window.__appBaseConfig__.WEB_BASE_API_URL + `${import.meta.env.VITE_WEB_API}`, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 8000, // request timeout
});

function needEncrypt () {
  return !!window.__appBaseConfig__.IS_ENCRYPT;
}

function normalizeBodyData (data) {
  if (data == null || data === '') return {};
  if (typeof data === 'object' && !(data instanceof FormData)) return { ...data };
  if (typeof data === 'string') {
    try {
      return qs.parse(data) || {};
    } catch (e) {
      return {};
    }
  }
  return {};
}

function encryptRequestConfig (config) {
  if (!needEncrypt()) return config;

  const method = (config.method || 'get').toLowerCase();
  const params = config.params || {};

  if (method === 'post') {
    // POST 业务参数可能在 params（拼到 URL）或 data（请求体），统一合并后再加密，避免明文残留在 query
    if (config.data instanceof FormData) {
      const formEntries = { ...params };
      config.data.forEach((value, key) => {
        formEntries[key] = value instanceof Blob ? (value.name || 'blob') : value;
      });
      const encryptedForm = new FormData();
      encryptedForm.append('encryptData', encrypt(formEntries));
      config.data = encryptedForm;
    } else {
      const payload = { ...params, ...normalizeBodyData(config.data) };
      config.data = qs.stringify({ encryptData: encrypt(payload) });
    }
    config.params = undefined;
  } else if (method === 'get') {
    const payload = params;
    const sep = (config.url || '').includes('?') ? '&' : '?';
    config.url = `${config.url}${sep}encryptData=${encodeURIComponent(encrypt(payload))}`;
    config.params = undefined;
  }

  return config;
}

function decryptResponseData (response) {
  if (!needEncrypt()) return;
  if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') return;
  if (response.data == null || response.data === '') return;

  if (typeof response.data === 'string' && isEncrypted(response.data)) {
    response.data = decrypt(response.data);
  }

  if (!response.data || typeof response.data !== 'object') return;

  if (typeof response.data.data === 'string' && isEncrypted(response.data.data)) {
    response.data.data = decrypt(response.data.data);
  }
  if (typeof response.data.rows === 'string' && isEncrypted(response.data.rows)) {
    response.data.rows = decrypt(response.data.rows);
  }
}

// request拦截器 request interceptor
service.interceptors.request.use(
  (config) => {
    if(window.__appBaseConfig__.IS_ENCRYPT && process.env.NODE_ENV === 'development'){
      console.log(config.url, config.data ?? config.params);
    }
    
    if (
      store.getters.token &&
      config.url.indexOf('dev-api/webApi/login') === -1
    ) {
      config.headers['Authorization'] = store.getters.token;
    }
    return encryptRequestConfig(config);
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  (response) => {
    setTimeout(() => {
      Toast.clear();
    }, 1000)
    decryptResponseData(response);
    const res = response.data;
    
    /* 免费购买成功返回响应 600 需要排除 */
    if (res.code && res.code !== 200 && res.code !== 600) {
      // 登录超时,重新登录
      if (res.code === 401) {
        if (isError) {
          // return;
        }
        console.log('登录超时,重新登录')
        store.dispatch('USER_LOGOUT')
        isError = true;
        store.dispatch('savePathInfo', { url: window.location.href });
        Dialog.confirm({
          message: res.msg || '登录失效,请重新登录',
          // theme: 'round-button',
          confirmButtonColor:'#028bff',
          confirmButtonText:'登录',
          cancelButtonText:'取消'
        }).then(() => {
          store.dispatch("LOGIN", { token: "" }).then(
            (s) => { },
            (e) => {
              console.error(e);
            }
          );
        }).catch(()=>{
          store.dispatch("USER_LOGOUT")
          router.replace('/')
        })
      } else {
        // Toast(res.msg || '登录失效,请重新登录')
        // store.dispatch('savePathInfo', { url: '' })
        // window.location.replace(`${location.origin}/web/#/index`)
        return Promise.resolve(res);
      }
    } else {
      // console.log(res);
      return Promise.resolve(res);
    }
  },
  (error) => {
    setTimeout(() => {
      Toast.clear();
    }, 1000)
    console.log('err' + error); // for debug
    return Promise.resolve(error);
  }
);

/* 带有缓存的请求 */
export const enhancedService = async (data) => {
  const requestKey = JSON.stringify(data);
  const catchedData = catcher.data[requestKey];
  if (catchedData) {
    if (+new Date() - catchedData.time > catcher.config.time) {
      console.info('缓存失效重新请求新数据');
    } else {
      return catchedData.data;
    }
  }

  const result = await service(data);
  catcher.data[requestKey] = {
    data: result,
    time: +new Date(),
  };
  return result;
};

export default service;
